module.exports = __webpack_public_path__ + "img/astro_astrotokensc.cf23da1.png";